import { Box, IconButton } from '@mui/material';
import AppRegistrationIcon from '@mui/icons-material/AppRegistration';
import { useShowContext } from 'framework/show';
import { FieldProps } from 'framework/ui/field';

interface EditActionFieldProps<T> extends FieldProps {
  onEdit: (entity: T) => void;
}

const EditActionField = <T,>({ onEdit }: EditActionFieldProps<T>) => {
  const { data } = useShowContext<T>();

  return (
    <Box sx={{ display: 'flex', justifyContent: 'flex-end', width: '100%' }}>
      <IconButton onClick={() => onEdit(data.getData())} size="small">
        <AppRegistrationIcon color="primary" />
      </IconButton>
    </Box>
  );
};

export default EditActionField;
